"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _tinymce = _interopRequireDefault(require("tinymce"));

function removeSpanIfBad(node) {
  if (node.attr('class') && node.attr('class').indexOf('hs_cos_wrapper_widget_container') >= 0) node.unwrap();
}

function removeWidgetContainerSpans(nodes) {
  nodes.forEach(removeSpanIfBad);
} // Band-aid fix for https://issues.hubspotcentral.com/browse/COSLP-1921
// Clean up widget container spans that get incorrectly cloned into widget contents
// Upstream issue tracked at https://github.com/tinymce/tinymce/issues/2798


function hspatchesPlugin(editor) {
  editor.on('PreInit', function () {
    editor.parser.addNodeFilter('span', removeWidgetContainerSpans);
    editor.serializer.addNodeFilter('span', removeWidgetContainerSpans);
  });
}

_tinymce.default.PluginManager.add('hspatches', hspatchesPlugin);